export default __webpack_public_path__ + "static/seatsplanet-bg-7b7502c7866d9a873015c52a6fb9afc5.jpg";